import { DeleteOutlined, EditOutlined, UnlockOutlined } from "@ant-design/icons";
import { Button, Input, Popconfirm, Space, Tooltip } from "antd";
import HTTPService from "../../../utils/makerequest";
import { IPageData, IPageProps } from "../../../interfaces/page-data";
import { useEffect, useRef, useState } from "react";
import { Toast } from 'primereact/toast';
import AltisDataGrid from "../../../AltisComponent/AltisDataGrid";
import { IAltisDataGridColumns } from "../../../AltisComponent/AltisDataGrid";
import { ICompanyData } from "../../../interfaces/ICompanyData";
import "../CompanyManagement/CustomerManagement.css";
import { t } from "i18next";
import i18n from "../../../i18n";
import { LockOpen } from "@material-ui/icons";
import MUIDatagrid, { IMUIDataGridColumns } from "../../../AltisComponent/MUIDataGrid";

export interface ICompany {
  count?: number;
  data?: ICompanyData[];
}

const CustomerManagement: React.FunctionComponent<IPageProps> = props => {
  const { onSetPage } = props;
  const [companyData, setCompanyData] = useState<ICompany>({});
  const [inputValue, setInputValue] = useState('');
  const dataGridRef = useRef<any>(null);
  const toast = useRef<any>(null);

  const pageData: IPageData = {
    title: t('customer_management'),
    loaded: true
  };

  useEffect(() => {
    onSetPage(pageData);
    dataGridRef.current.GetAllData();
  }, [i18n.language]);

  const columns: IMUIDataGridColumns[] = [
    {
      title: t('Customer Name'),
      key: 'companyName',
      placeHolder: t('Customer Name'),
      isSorting: true,
      width: 200,
    },
    {
      title: t('city'),
      key: 'companyCity',
      placeHolder: t('city'),
      isSorting: true,
      width: 200,
    },
    {
      title: t('firstName'),
      key: 'firstName',
      placeHolder: t('firstName'),
      isSorting: true,
    },
    {
      title: t('lastName'),
      key: 'lastName',
      placeHolder: t('lastName'),
      isSorting: true,
    },
    {
      title: t('telephone'),
      key: 'telephone',
      isSorting: true,
      placeHolder: t('telephone'),
    },
    {
      title: t('email'),
      key: 'userEmail',
      isSorting: true,
      placeHolder: t('email'),
    },
    {
      title: t('Operations'),
      key: 'operations',
      placeHolder: t('Operations'),
      hideColumnMenu: true,
      render: (order, record) => (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
          <Space size={10}>
            <Popconfirm
              title={
                <div>
                  {t('deleteConfirmation')} <strong>{record.companyName}</strong> ? <br />
                  {t('deleteConfirmation2')}
                  <Input
                    placeholder={t('deleteTypeCompany')}
                    onChange={(e) => setInputValue(e.target.value)}
                    style={{ marginTop: 10 }}
                  />
                </div>
              }
              okText={t('yes')}
              cancelText={t('no')}
              onConfirm={() => {
                if (inputValue === record.companyName) {
                  DeleteCompany(record.companyId);
                } else {
                }
              }}
            >
              <Tooltip title={t('delete')}>
                <Button
                  size='small'
                  icon={<DeleteOutlined />}
                  style={{ width: '60px', borderRadius: '70px' }}
                  onClick={(e) => { e.stopPropagation(); }}
                >
                </Button>
              </Tooltip>


            </Popconfirm>
            <Tooltip title={t('update')}>

              <Button
                size='small'
                icon={<EditOutlined />}
                style={{ width: '60px', borderRadius: '70px' }}
                onClick={() => {
                  const companyId = record.companyId;
                  window.location.replace('/admin/update-company/' + companyId);
                }
                }
              ></Button>
            </Tooltip>

            {record.licenceToken === null ? (
              <Tooltip title={t('addLicence')}>
                <Button
                  size='small'
                  icon={<LockOpen />}
                  style={{ width: '60px', borderRadius: '70px' }}
                  onClick={() => {
                    const companyId = record.companyId;
                    window.location.replace(`/admin/add-licence/${companyId}/1`);
                  }}
                />
              </Tooltip>
            ) : (
              <Tooltip title={t('transferLicence')}>
                <Button
                  size='small'
                  icon={<UnlockOutlined />}
                  style={{ width: '60px', borderRadius: '70px' }}
                  disabled={!record.licenceKey}
                  onClick={() => {
                    const licenceKey = record.licenceKey;
                    const companyId = record.companyId;
                    window.location.replace(`/admin/transfer-licence/${licenceKey}/${companyId}/1`);
                  }}
                />
              </Tooltip>
            )}
          </Space>
        </div>
      ),
    },
  ];

  const CompanyFilter = (e?) => {
    const sortColumn = e?.sortColumn;
    const sortOrder = e?.sortOrder || 'asc';
    var body = {
      sortColumn,
      sortOrder,
      pageSize: e?.pageSize,
      page: e?.page,
      companyName: e?.companyName,
      companyCity: e?.companyCity,
      responsibleFirstname: e?.firstName,
      responsibleLastname: e?.lastName,
      responsibleTelephone: e?.telephone,
      responsibleEmail: e?.userEmail,
    };

    HTTPService.POST(`/Company/filters`, body).then((response) => {
      if (!response.data) return;
      if (response.status === 200) {
        setCompanyData(response.data);
      } else {
        toast.current?.show({
          severity: 'error',
          summary: t('errors'),
          detail: t(response.data),
          life: 3000
        });
      }
      let tmp: ICompany = response.data;
      tmp.data?.map((elem, index) => {
        elem['key'] = index;
      });
      setCompanyData(tmp);
    });
  };

  const DeleteCompany = (Id) => {
    HTTPService.DELETE(`/Company/deleteCompany?Id=${Id}`).then(
      (response) => {
        if (response.status === 200) {
          toast.current?.show({
            severity: 'success',
            summary: t('successful'),
            detail: t(response.data),
            life: 3000
          });
          dataGridRef.current.GetAllData();
        } else {
          toast.current?.show({
            severity: 'error',
            summary: t('errors'),
            detail: t('error450'),
            life: 3000
          });
        }
      }
    );
  };

  return (
    <>
      <Toast ref={toast} />
      <div className="row">
        <div className="col-md-4 mb-3">

          <Button
            type='primary'
            shape='round'
            style={{ height: 40, borderRadius: '5px', marginBottom: 20 }}
            size='middle'
            onClick={() => window.location.replace('/admin/add-customer')}
          >
            {t('add_new_customer')}
          </Button>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <div className="table-container">
            <MUIDatagrid ref={dataGridRef} data={companyData.data} total={companyData.count} columns={columns} onChange={CompanyFilter} />
          </div>
        </div>

      </div>
    </>
  );
}
export default CustomerManagement;